import React from 'react';
import { usePbmComboRevert } from '@/hooks/use-pbm-combo-revert';

/**
 * Keeps combo prices in sync when items are removed with the cart sidebar closed.
 */
const CartPbmComboGuard: React.FC = () => {
  usePbmComboRevert();
  return null;
};

export default CartPbmComboGuard;
